module.exports = __webpack_public_path__ + "static/img/cr_header_combo.bb6329c8.png";